import { textoDelProgreso } from '../../api/importacion'
import type { ProgresoDeAlta } from '../../api/alta'
import type { Alta } from '../../api/tipos'

/**
 * Lo que la pantalla de progreso dice del paso «Importar tus productos» mientras no tiene su
 * propio mensaje (el resumen, o por qué no se importaron, los escribe el núcleo al acabar el
 * paso): cómo va la importación, con las mismas palabras que Productos → Importar.
 */
export const lineaDeProductos = (paso: Alta['pasos'][number], productos: ProgresoDeAlta['productos']): null | string => {
  if (paso.mensaje || paso.estado !== 'pendiente') return null
  if (!productos) return null
  const { importacion } = productos
  if (!importacion) {
    const filas = productos.filas
    return `Se importarán ${filas === null ? 'los productos' : `${filas} ${filas === 1 ? 'fila' : 'filas'}`}${productos.archivo ? ` de «${productos.archivo}»` : ''} antes de montar los menús.`
  }
  if (importacion.cortada) return 'La importación se ha cortado: se retoma sola en unos minutos, desde el último producto guardado.'
  if (importacion.estado === 'en-cola' || importacion.estado === 'en-curso') return textoDelProgreso(importacion)
  return null
}

/** Si el paso de productos merece un enlace a Productos → Importar: cuando no se importaron con la web. */
export const conEnlaceAImportar = (paso: Alta['pasos'][number]): boolean => paso.clave === 'productos' && (paso.estado === 'fallido' || paso.estado === 'omitido')
